module Environments {

    export class AgentDetailsController {
        public environment: IEnvironment;
        public agentGroup: IAgentGroup;
        public agentName: string;
        public processGuid: string;
        public agent: IAgent;
        public selectedProcess: number;
        public selectedTriggers: IAgentProcessesTriggers[];
        public triggerOpen: boolean;
        public eventOpen: boolean;
        public eventsPage: number;
        public totalEvents: number;

        public static $inject = ["$stateParams", "AgentsService", "EnvironmentsService", "$state", "$scope"];
        constructor($stateParams, public agentsService: AgentsService, public environmentService: any, $state: angular.ui.IStateService, $scope: IAgentScope) {
            this.agentName = $stateParams.agentName;
            this.processGuid = $state.params["processGuid"];
            this.environment = $scope.environment;
            this.agentGroup = $scope.agentGroup;
            this.triggerOpen = true;
            this.eventOpen = true;
            this.eventsPage = 1;

            this.agent = _.find<IAgent>(this.agentGroup.executionAgents.concat(this.agentGroup.gatewayAgents), (agent) => {
                return agent.name === this.agentName;
            });

            if (!this.agent) {
                var environment = this.environment.name || "Default";
                $state.go("environments.detail", { environmentName: environment });
            };

            this.refreshEvents();

            this.agentsService.getTriggers(this.agent.name, this.agentGroup.name).then((response) => {
                if (response && response.data!=null && response.data.length > 0) {
                    this.agent.triggers = response.data;
                    if (this.processGuid) {
                        var index = this.findProcessByprocessGuid(this.processGuid);
                        this.showDetailedTriggerInfo(index);
                    } else {
                        this.showDetailedTriggerInfo(0);
                    }
                }
            });
        }

        private refreshEvents() {
            this.agentsService.getEvents(this.agent.name, this.agentGroup.name, this.environment.name, this.eventsPage)
                .then((response) => {
                    if (response) {
                        this.agent.events = response.data.agentEvents;
                        this.totalEvents = response.data.totalEvents;
                    }
                });
        }

        public changePage = () => this.refreshEvents();

        private findProcessByprocessGuid(processGuid): number {
            return this.agent.triggers.map((process) => process.processGuid).indexOf(processGuid);
        }

        public showDetailedTriggerInfo(index: number) {
            this.selectedProcess = index;
            this.selectedTriggers = this.agent.triggers[index].agentTriggerViewModel;
        }

        public toggleEvent(event: any) {
            event.showEvent = !event.showEvent;
        }
    }

    module.controller("AgentDetailsController", AgentDetailsController);

    export interface IEnvironmentsService {
        populateEnvCache: () => any;
        all: () => any;
        save: (env: IEnvironment) => any;
        remove: (env: IEnvironment) => any;
        createTemporaryEnv: () => IEnvironment;
        createTemporaryAgentGroup: () => IAgentGroup;
        validateConnectionString: (connectionString: string) => any;
        synchronizeAgents: (agentGroup: IAgentGroup) => any;
        saveAgentGroup: (agentGroup: IAgentGroup, environment: IEnvironment) => any;
    }

    export interface IAgentService {
        get: (agent) => any;
        getEvents: (agentName, agentGroupName, environmentName, page) => any;
        getTriggers: (agentName, agentGroupName) => any;
        save: (agent) => any;
        remove: (agent) => any;
        getNewAgent: (environment, agentGroup, isGateway: boolean) => any;
        download: (agentId) => any;
    }

    export interface IEnvironment {
        id: number;
        name: string;
        agentGroups: IAgentGroup[];

        isNew: boolean;
    }

    export interface IAgentGroup {
        id: number;
        name: string;
        connectionString: string;
        configurationJson: string;
        isFarm: boolean;
        executionAgents: IAgent[];
        gatewayAgents: IAgent[];

        isNew: boolean;
    }

    export interface IAgent {
        editUrl: string;
        deleteUrl: string;
        id: number;
        name: string;
        lastStatus: string;
        lastUpdated: string;
        errorEventDuringLastDay: boolean;
        isGateway: boolean;
        events: IAgentEvents[];
        triggers: IAgentProcesses[];
        agentGroup: IAgentGroup;
    }

    export interface IAgentEvents {
        eventId: number;
        level: string;
        utcTimestamp: string;
        category: string;
        source: string;
        message: string;
    }

    export interface IAgentProcesses {
        agentTriggerViewModel: IAgentProcessesTriggers[];
        name: string;
        processGuid: string;
        triggersActive: boolean;
        version: string;
    }

    export interface IAgentProcessesTriggers {
        triggerUri: string;
        triggerGuid: string;
        triggerName: string;
        triggerType: string;
        triggerDescription: IAgentProcessesTriggerDescription;
    }

    export interface IAgentProcessesTriggerDescription {
        generalDescription: string;
        triggerPath: string;
    }

    export interface IAgentScope extends ng.IScope {
        environment: IEnvironment;
        agentGroup: IAgentGroup;
        agent: any;
        $state: any;
        $stateParams: any;
    }
}


